var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lineReport"},[_c('div',{staticClass:"myChart",staticStyle:{"width":"100%","height":"300px"},attrs:{"id":_vm.lineDatas.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }